
<mat-icon (click)="share()"  style="height: 44px;">share</mat-icon>
